import { useMemo } from 'react'
import { UserQualificationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'
import { ContentUserQualifications, ContentUserQualificationsSkeleton } from '@tabeeb/modules/contentUsers/components'
import { Subheader3 } from '@collaborate-health/uikit'

export interface UseQualificationsRenderProps {
  qualificationForInvitesEnabled: boolean
  areQualificationsLoading: boolean
  userQualifications?: UserQualificationResponse[] | null
  qualificationsFailedToLoad: boolean
}

export default function useContentUserQualificationsRender({
  qualificationForInvitesEnabled,
  areQualificationsLoading,
  userQualifications,
  qualificationsFailedToLoad,
}: UseQualificationsRenderProps): JSX.Element | null {
  return useMemo(() => {
    if (!qualificationForInvitesEnabled) {
      return null
    }

    if (areQualificationsLoading && !userQualifications) {
      return <ContentUserQualificationsSkeleton />
    }

    if (userQualifications && userQualifications.length > 0) {
      return <ContentUserQualifications qualifications={userQualifications} />
    }

    if (qualificationsFailedToLoad) {
      return <Subheader3>Failed to load qualifications</Subheader3>
    }

    return <Subheader3>No qualifications required</Subheader3>
  }, [qualificationForInvitesEnabled, areQualificationsLoading, userQualifications, qualificationsFailedToLoad])
}

